import { Page, SHORTCUT } from '@app/ui';
import { useTranslation } from 'react-i18next';
import { ChangePasswordPanel } from '@app/main/widgets/Users.PasswordChange';
import { Form } from '@webinex/antik';
import { Col, Row } from 'antd';

export function UserChangePasswordPage() {
  const { t } = useTranslation();
  const title = t('users.passwordChange.title');

  return (
    <Page htmlTitle={title}>
      <Page.Body>
        <Page.Card
          title={title}
          actions={
            <Form.Submit
              data-shortcut={SHORTCUT.save}
              data-test="change-password-save"
              type="primary"
              uid="password-change"
            >
              {t('save')}
            </Form.Submit>
          }
        >
          <Row>
            <Col xs={24} sm={24} md={20} lg={16}>
              <ChangePasswordPanel />
            </Col>
          </Row>
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
